import Card from '@material-ui/core/Card'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { IconPermIdentity } from '@components/atoms/icons'
import PropTypes from 'prop-types'
import ButtonCta from '@components/atoms/button-cta'
import Image from '@components/atoms/image'
import WatchVideo from './watch-video'
import useStyles from './category-slider-card.styles'

const CategorySliderCard = (props) => {
  const {
    headline,
    summary,
    ctaText,
    externalLink,
    secondaryCtaText,
    image,
  } = props

  const videoID = secondaryCtaText

  const styles = useStyles()

  return (
    <Card className={styles.root}>
      <Box className={styles.contentContainer}>
        {image?.url ? (
          <Image
            className={styles.coachImage}
            src={image?.url}
            alt={headline}
          />
        ) : (
          <IconPermIdentity className={styles.coachImage} />
        )}
        <Typography
          className={styles.coachName}
          variant="h5"
          variantMapping={{ h5: 'h3' }}
        >
          {headline}
        </Typography>
        <Typography variant="caption" className={styles.facilityName}>
          {summary}
        </Typography>
        {videoID && <WatchVideo videoID={videoID} headline={headline} />}
      </Box>
      <ButtonCta
        variant="text"
        arrow
        externalLink={externalLink}
        className={styles.ctaButton}
        dataAttrs={{ 'aria-label': `External link to ${headline} page` }}
      >
        {ctaText}
      </ButtonCta>
    </Card>
  )
}

CategorySliderCard.propTypes = {
  headline: PropTypes.string,
  summary: PropTypes.string,
  ctaText: PropTypes.string,
  externalLink: PropTypes.string,
  secondaryCtaText: PropTypes.string,
  image: PropTypes.object,
}

CategorySliderCard.defaultProps = {}

export default CategorySliderCard
